export const overflow = (value) => value >>> 16;
export const clamp = (value) => value & 0xffff;
export function fromNumber(value) {
    return [clamp(value), overflow(value), 0, 0];
}
export function toNumber(value) {
    return value[1] * 2 ** 16 + value[0];
}
/**
 * Represents the zero value, or `[0, 0, 0, 0]`.
 * @readonly
 * @group Constants
 */
export const ZERO = fromNumber(0);
export function clampBlocks([v0, v1, v2, v3]) {
    return [clamp(v0), clamp(v1), clamp(v2), clamp(v3)];
}
//# sourceMappingURL=u64.js.map